<div>
    <div class="row" style="height: 12vh;">
        <div class="col-md-4"></div>
        <div class="col-md-4">
            <button
                name="sendInvoices"
                id="sendInvoices"
                class="btn rail360-primary-item btn-rectangle-lg"
                (click)="sendInvoices()"
                [disabled]="emailContactsLoading || notReadyToSendEmails() || hasCustomerContactError">
                Send Emails</button>
        </div>
        <div class="col-md-4"></div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <h2 style="padding-left: 1em;">Contacts</h2>
            <kendo-grid
                [data]="selectedInvoices"
                [loading]="emailContactsLoading"
                style="height: calc(78vh - 90px)"
                [sort]="sort"
                [sortable]="{
                    allowUnsort: true,
                    mode: 'single'
                }"
                [rowClass]="rowCallback"
                (sortChange)="sortChange($event)">
                <kendo-grid-column title="{{invoiceColumnTitle}}" field="invoiceNumber" width="15%"></kendo-grid-column>
                <kendo-grid-column *ngIf="!hideLeaseColumn" title="Rider" field="leaseNumber" width="15%"></kendo-grid-column>
                <kendo-grid-column *ngIf="!hideCustomerColumn" title="{{customerColumnTitle}}" field="customerName" width="30%"></kendo-grid-column>
                <kendo-grid-column title="Email" field="email" width="32%">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div [ngStyle]="{'color': dataItem.email?.startsWith('Warning') ? 'var(--warning)' : ''}">{{dataItem.email}}</div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column *ngIf="!hidePostedColumn" title="Posted" width="8%">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div style="display: flex;">
                            <div>
                                <span kendoTooltip *ngIf="dataItem.postedDate" position="left" class="m-l-xs" >
                                    <i id="details" class="fa fa-lg fa-check" title="Posted to Intacct on {{dataItem.postedDate | date: 'MM/dd/yyyy'}}"></i>
                                </span>
                                <span kendoTooltip *ngIf="!dataItem.postedDate && isCarHireZeroValueRecord(dataItem)" position="left" class="m-l-xs" >
                                    <i id="details" class="fa fa-lg fa-times" title="Not Posted to Intacct."></i>
                                </span>
                            </div>
                        </div>
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </div>
</div>